var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-coupons user-coupons--collapsed" }, [
    _c("h3", {
      staticClass: "user-coupons__title",
      domProps: { innerHTML: _vm._s(_vm.$t("checkout.couponUserTitle")) }
    }),
    _vm._v(" "),
    _c("div", { ref: "wrapper", staticClass: "user-coupons__wrapper" }, [
      _c("div", {
        staticClass: "user-coupons__trigger",
        class: {
          "user-coupons__trigger--disabled": _vm.disabled
        },
        domProps: { innerHTML: _vm._s(_vm.$t("checkout.couponUserLabel")) }
      }),
      _vm._v(" "),
      _c("fieldset", { staticClass: "user-coupons__list" }, [
        _c(
          "div",
          { staticClass: "user-coupons__list-wrapper" },
          _vm._l(_vm.coupons, function(coupon) {
            return _c(
              "label",
              { key: coupon.value, staticClass: "user-coupons__coupon" },
              [
                _c("input", {
                  staticClass: "user-coupons__coupon-input",
                  attrs: { type: "radio", name: "user-coupons" },
                  domProps: { value: coupon.code, checked: coupon.active },
                  on: { change: _vm.onChange }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "user-coupons__coupon-wrapper" }, [
                  _c("div", { staticClass: "user-coupons__coupon-info" }, [
                    _c("span", {
                      staticClass: "user-coupons__coupon-name",
                      domProps: { innerHTML: _vm._s(coupon.title) }
                    }),
                    _vm._v(" "),
                    coupon.validUntil
                      ? _c("span", {
                          staticClass: "user-coupons__coupon-expiration",
                          domProps: {
                            innerHTML: _vm._s(_vm.formatDate(coupon.validUntil))
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    coupon.validity
                      ? _c("span", {
                          staticClass: "user-coupons__coupon-expiration",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("checkout.couponValidity", {
                                validity: coupon.validity
                              })
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    coupon.exclusive
                      ? _c("span", {
                          staticClass: "user-coupons__coupon-expiration",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("checkout.couponUserExclusive")
                            )
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "user-coupon__value",
                    domProps: {
                      innerHTML: _vm._s(_vm.formatDiscount(coupon.discount))
                    }
                  })
                ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }